export const comments_3249782 = {"data":{"data":[],"links":{}}}